import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.75 8.248v7.5m5.055-7.5v7.5M.75 11.998a11.25 11.25 0 1 0 22.5 0 11.25 11.25 0 1 0-22.5 0"
    }, null, -1)
  ]));
}
const entertainmentControlButtonCirclePause = { render };
export {
  entertainmentControlButtonCirclePause as default,
  render
};
//# sourceMappingURL=entertainment-control-button-circle-pause.svg.js.map
